<template>
  <div>
    <footer id="main-footer">
      <div class="container">
        <div class="row">
          <div class="col text-center py-2 text-muted" style="font-size: 14px">
            <p>Copyright &copy; Chan Chao Int'l Co., Ltd.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style lang="scss">
  #main-footer {
    padding-top: 7px;
    bottom: 0;
  }
</style>
